import './index_mWeb.css';
import React, { useState } from 'react';
import useTheme from '../../utilities/hooks/theme';
import { convertToDollars, RoundedOffAmount } from '../../utilities/helper';
import Card from '../card';
import Constants from '../../constants';
import View from '../view';
import Text from '../text';

type walletTypeProps = {
  title?: String | undefined;
  value?: any;
  theme?: any;
};
const WalletType = ({ title, value = 0, theme }: walletTypeProps) => {
  const contentTextColor = {
    color: theme.transactionContentText
  };
  value = RoundedOffAmount(value);
  if (value <= 0) return null;
  return (
    <View className={'transaction-game-item-wallet-type-wrapper'}>
      <Text
        style={contentTextColor}
        className={'transaction-game-item-wallet-type-title'}>{`${title}`}</Text>
      <Text
        style={contentTextColor}
        className={'transaction-game-item-wallet-type-value'}>{`${convertToDollars(
        value
      )}/-`}</Text>
    </View>
  );
};

interface Props {
  item: any;
}

const TransactionGameItemMWeb = ({ item }: Props) => {
  const { AccountTheme: theme } = useTheme();
  const [expanded, setExpanded] = useState(false);
  const {
    amount = 0,
    gameId = '',
    refund = '',
    transactionType = '',
    totalTax = 0,
    comment = null,
    transfer = false,
    isPoker = false,
    walletBreakup
  } = item;
  const newAmount = RoundedOffAmount(amount);

  const statusColor =
    transactionType === 'debit' ? theme.transactionDebit : theme.transactionCredit;

  const surfaceColor = {
    backgroundColor: 'rgb(14, 14, 28,70%)',
    boxShadow: '0 3px 16px 0 rgba(0, 0, 0, 0.16)'
  };

  const simpleTextColor = {
    color: theme.transactionDateTime
  };

  const contentColor = {
    borderTopColor: theme.transactionExpandIconBorder,
    borderLeft: `8px solid ${statusColor}`
  };

  const isTransfer = transfer && !gameId;
  const isExpandableItem = amount > 0;
  return (
    <Card style={surfaceColor} className={'transaction-game-item-container__mWeb'}>
      <View
        onPress={() => {
          if (isExpandableItem) setExpanded(!expanded);
        }}
        style={{ borderLeft: `8px solid ${statusColor}` }}
        className={'transaction-game-item-header__mWeb'}>
        <View className={'transaction-game-item-header-wrapper '}>
          <View className={'transaction-game-item-left-part'}>
            {transactionType === 'debit' && (
              <Text
                style={{
                  fontFamily: 'Poppins',
                  color: statusColor
                }}
                className={'transaction-game-item-header__mWeb'}>
                {isPoker ? 'Join Room / Buy In' : 'Joined Contest'}
              </Text>
            )}

            {transactionType === 'credit' && (
              <Text
                style={{
                  fontFamily: 'Poppins',
                  color: statusColor
                }}
                className={'transaction-game-item-header__mWeb'}>
                {refund
                  ? 'Got Refund'
                  : isPoker
                  ? 'Credited Back'
                  : comment
                  ? 'Winning adjustment'
                  : isTransfer
                  ? 'Transfer'
                  : 'Won Contest'}
              </Text>
            )}
            {comment && (
              <Text
                style={simpleTextColor}
                className={'transaction-game-item-content-text'}>{`Comment : ${comment}`}</Text>
            )}
          </View>
          <View className={'transaction-game-item-right-part'}>
            <Text style={{ color: statusColor }} className={'transaction-game-item-amount'}>
              {`${transactionType === 'credit' ? '+' : '-'} ${convertToDollars(newAmount)}`}
            </Text>
          </View>
        </View>
        {!isTransfer && (
          <>
            {/* <View style={expandDivider} className={'transaction-game-item-expand-divider'} /> */}
            <View className={'transaction-game-item-expand-wrapper'}>
              {expanded ? (
                <Constants.Svgs.ArrowCollapse fill={theme.transactionExpandIcon} />
              ) : (
                <Constants.Svgs.ArrowExpand fill={theme.transactionExpandIcon} />
              )}
            </View>
          </>
        )}
      </View>
      {expanded && !comment && !isTransfer && (
        <View style={contentColor} className={'transaction-game-item-content'}>
          {totalTax > 0 && transactionType === 'credit' && (
            <WalletType title={'TDS'} value={`₹ ${totalTax}`} theme={theme} />
          )}
          {transactionType == 'credit' && refund ? (
            <>
              <WalletType
                title={'iGamio Wallet'}
                value={`${walletBreakup['primaryWalletRefund']}`}
                theme={theme}
              />

              <WalletType
                title={'Winnings Wallet'}
                value={`${walletBreakup['gameWalletRefund']}`}
                theme={theme}
              />

              <WalletType
                title={'Bonus Wallet'}
                value={`${walletBreakup['bonusWalletRefund']}`}
                theme={theme}
              />
              <WalletType
                title={'CashBack Wallet'}
                value={`${walletBreakup['cashbackWalletRefund']}`}
                theme={theme}
              />
              {isPoker && (
                <WalletType
                  title={'Poker Wallet'}
                  value={`${walletBreakup['pokerWalletRefund']}`}
                  theme={theme}
                />
              )}
            </>
          ) : transactionType == 'credit' ? (
            <>
              {isPoker ? (
                <WalletType
                  title={'Poker Wallet'}
                  value={`${walletBreakup['totalWinnings']}`}
                  theme={theme}
                />
              ) : (
                <WalletType
                  title={'Winnings Wallet'}
                  value={`${walletBreakup['totalWinnings']}`}
                  theme={theme}
                />
              )}
            </>
          ) : (
            <>
              <WalletType
                title={'iGamio Wallet'}
                value={`${walletBreakup['primaryWalletEntryFee']}`}
                theme={theme}
              />

              <WalletType
                title={'Winnings Wallet'}
                value={`${walletBreakup['gameWalletEntryFee']}`}
                theme={theme}
              />

              <WalletType
                title={'Bonus Wallet'}
                value={`${walletBreakup['bonusWalletEntryFee']}`}
                theme={theme}
              />
              <WalletType
                title={'CashBack Wallet'}
                value={`${walletBreakup['cashbackWalletEntryFee']}`}
                theme={theme}
              />
              {isPoker && (
                <WalletType
                  title={'Poker Wallet'}
                  value={`${walletBreakup['pokerWalletEntryFee']}`}
                  theme={theme}
                />
              )}
            </>
          )}
        </View>
      )}
    </Card>
  );
};
TransactionGameItemMWeb.defaultProps = {};
export default React.memo(TransactionGameItemMWeb);
